
    import Vue from 'vue';
    import TabOne from './tabsClient/tab-oneClient.vue';
    import { tabValidation, toViewModel } from '@/apps/shared/utils/NF';
    import XBreadcrumb from '@/apps/shared/components/breadcrumb.vue';
    import webSaleHelper from '@/apps/shared/utils/webSaleHelper';

    export default Vue.extend({
        components: {
            TabOne,
            XBreadcrumb
        },
        busEvents: {
            enablePrevButton() {
                this.$refs.wizard?.enableButton("prev");
            },
            disablePrevButton() {
                this.$refs.wizard?.disableButton("prev");
            },
            hiddenPrevButton() {
                this.$refs.wizard?.hideButton("prev");
            },
            enableNextButton() {
                this.$refs.wizard?.showButton("next");
            },
            disableNextButton() {
                this.$refs.wizard?.hideButton("next");
            },

            enableFinalButton() {
                this.$refs.wizard?.enableButton("final");
            },

            disableFinalButton() {
                this.$refs.wizard?.disableButton("final");
            },

            ShowFinalButton() {
                this.$refs.wizard?.showButton("final");
            },

            hiddenFinalButton() {
                this.$refs.wizard?.hideButton("final");
            },
            redirectSummary() {
                if (this.$route.path !== '/hogar-premium/resumen') {
                    this.$router.push({ name: 'HogarPremiumSummary' }).catch(err => {
                        // Si la redirección falla por cualquier motivo, no hacer nada.
                        if (err.name !== 'NavigationDuplicated') {
                            console.error('Error en la navegación:', err);
                        }
                    });
                }
            },
            redirectPlan() {
                if (this.$route.path !== '/hogar-premium/elegiPlan') {
                    this.$router.push({ name: 'tabFiveFamilyCombinedPremium' }).catch(err => {
                        // Si la redirección falla por cualquier motivo, no hacer nada.
                        if (err.name !== 'NavigationDuplicated') {
                            console.error('Error en la navegación:', err);
                        }
                    });
                }
            }
        },
        name: 'FamilyHogarPremiumClientData',
        data() {
            return {
                BreadcrumbText: "Datos personales",
                stepOneData: null,
                stepTwoData: null,
                stepThreeData: null,
                activeStep: 0,
                coberturas: null,
                precioSinDescuento: null,
                rate: null,
                localItems: [{ text: 'Inicio', path: '/hogar-premium' }],
                wizard: {
                    showStepName: false,
                    type: NF.Wizard.Type.PILLS,
                    mode: NF.Wizard.Mode.STEP_BY_STEP,
                    validationMode: NF.Wizard.ValidationMode.ALWAYS,
                    buttons: {
                        final: { text: 'Contratar', class: 'btn btn-default' },
                        next: { text: 'Siguiente', class: 'btn btn-default' }
                    },
                    footer: {
                        align: NF.Wizard.Footer.Align.SPACE_BETWEEN,
                    },
                    steps: [
                        {
                            displayName: '',
                            content: '#step1',
                            viewModel: toViewModel(TabOne),
                            validate: (config, direction) => tabValidation(config, direction),
                            onEnter: function () {
                                this.Bus.$emit('enablePrevButton');
                                this.Bus.$emit('disableFinalButton');
                            },
                        },
                    ],
                },
            };
        },
        methods: {
            async pageCustomization() {
                const defaultTitle = 'Hogar Premium';
                const actualPath = '/hogar-premium';
                // Llamamos al helper que se encarga de toda la lógica
                try {
                    await webSaleHelper.pageCustomization(this.$route, this.Bus, this.$store, defaultTitle, actualPath, null, null);
                }
                catch (error) {
                    const statusCode = error.response.status;
                    this.Bus.$emit(
                        'show-service-fail',
                        statusCode,
                        [() => this.pageCustomization()]);
                }
            },

            updateByProductGoogleAnalytics() {
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                const productGtmName = 'DefaultFamilyCombinedGTMInfo';
                this.Bus.$emit('updateByProductGoogleAnalytics', productGtmName);
            },

            showFileError(errorMessage) {
                NF.Notification.show({
                    type: NF.Notification.Type.ERROR,
                    title: 'Error',
                    content: errorMessage,
                    position: NF.Notification.Positions.TOP_RIGHT,
                    clickClose: true,
                    autoHideDelay: 0
                })
            },
            open: function () {
                this.$refs.modal.open();
            },
            close: function () {
                this.$refs.modal.close();
            },
            getFilePath() {
                this.close();

                const rutaAlternativa = sessionStorage.getItem("rutaAlternativa");
                if (rutaAlternativa) {
                    this.$router.push(rutaAlternativa);
                }
                else {
                    this.$router.push({ name: 'tabOneFamilyCombinedPremium' });
                }
            },
            getInitData() {
                sessionStorage.setItem("ExitOrContinueModal", "true");
                this.Bus.$on('step-one-data', (stepData) => this.stepOneData = stepData);
                this.Bus.$on('step-two-data', (stepData) => this.stepTwoData = stepData);
                var planDataSelected = sessionStorage.getItem("PlanSelected")
                if (planDataSelected != null) {
                    this.DataPlan = JSON.parse(planDataSelected!);
                    this.planDescription = this.DataPlan.planDescription;
                    this.primerCuota = this.DataPlan.premioMensualFormatted
                    this.precioSinDescuento = this.DataPlan.premioMensualSinDescuentoFormatted
                    this.coberturas = this.DataPlan.plans
                    var DataQuotation = sessionStorage.getItem("DataQuotation");
                    this.QuotationJson = JSON.parse(DataQuotation!);
                    if (DataQuotation != null) {
                        this.rate = this.QuotationJson.discountRate;
                    }
                }
            }
        },
        async mounted() {
            try {
                NF.UI.Page.block();

                const parallelPromises = [
                    this.pageCustomization(),
                    this.updateByProductGoogleAnalytics(),
                    this.getInitData()
                ];

                await Promise.all([
                    ...parallelPromises,
                ]);

            } finally {
                NF.UI.Page.unblock();
            }
        },
    })
